/**
 * 今日到店模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/visits(\?)/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'visits|10': [{
      'id|+1': 1,
      'car_id|+1': 1,
      'insurance_expires_in': -15,
      'insurance_expires_on': '2016-10-31',
      'plate_number': '粤B12345',
      'insurance_rating': /未知|A|B|C|D|E/,
      'employee_name': /黄某某|朱某某|史某某|游某某/,
      'visited_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss')
    }],
    'total_count': 40,
    'page|+1': 1,
    'count': 10
  }
})
